import { LitElement, html, css } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { StyleSheet } from "/modules/styleSheet.js";

/**
 * Detect the current UI type (legadom or antilles) based on URL path
 */
function detectUIType() {
	const path = window.location.pathname;
	if (path.includes('/legadom/') || path.startsWith('/legadom')) {
		return 'legadom';
	}
	return 'antilles';
}

export class ButtonCategory extends LitElement {
	static properties = {
		name : {type : String},
		code : {type : String},
		active : {type : Boolean},
		onClickHandler: { type: Function, attribute: false }
	}
	
	static get styles() {
		const uiType = detectUIType();
		return [
			new StyleSheet ('/vendor/bootstrap/bootstrap.min.css').styles,
			new StyleSheet (`/${uiType}/include/site.css`).styles
		];
  	}

	render (){
		return html`
			<button
				class="${this.active ? 'bouton_selection active' : 'bouton_selection'}"
				data-legal-form-code="${this.code}"
				@click="${this.handleClick}">${this.name}
			</button>
		`;
	}
	
	handleClick (){
		if (this.onClickHandler && typeof this.onClickHandler === "function")
			this.onClickHandler (this.code);
	}
}

customElements.define ("button-category", ButtonCategory);
